import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const CHART_COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#6366F1', '#EC4899', '#8B5CF6'];

const TOOLTIP_STYLE = {
  borderRadius: '12px',
  border: 'none',
  boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
  fontSize: '10px',
  fontWeight: '600',
  padding: '8px 12px'
};

/**
 * A compact donut chart with an inline legend list on the right side.
 *
 * @param {Array}   data        - Array of { name, value } objects.
 * @param {Array}   colors      - Optional custom color palette (defaults to CHART_COLORS).
 * @param {number}  colorOffset - Start index offset into the color palette (default 0).
 * @param {string}  label       - Small title displayed above the chart row.
 * @param {string}  labelColor  - Tailwind text-color class for the label (e.g. "text-emerald-600").
 * @param {number}  maxLegend   - Max number of legend items to show (default 5).
 */
const DonutWithLegend = ({
  data = [],
  colors = CHART_COLORS,
  colorOffset = 0,
  label,
  labelColor = 'text-slate-500',
  maxLegend = 5,
}) => (
  <div className="flex flex-col h-full w-full justify-center">
    {label && (
      <div className={`text-[9px] font-bold ${labelColor} mb-1  tracking-wider text-center`}>
        {label}
      </div>
    )}
    <div className="flex items-center gap-2 h-[80px] w-full">
      {/* Donut */}
      <div className="h-[70px] w-[70px] flex-shrink-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip contentStyle={TOOLTIP_STYLE} />
            <Pie
              data={data}
              cx="50%" cy="50%"
              innerRadius={16} outerRadius={30}
              paddingAngle={2} dataKey="value" nameKey="name"
            >
              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[(index + colorOffset) % colors.length]}
                  stroke="none"
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Legend */}
      <div className="flex flex-col justify-center gap-[3px] flex-1 min-w-0">
        {data.slice(0, maxLegend).map((entry, index) => (
          <div key={index} className="flex items-center gap-1 min-w-0">
            <div
              className="w-[6px] h-[6px] rounded-full flex-shrink-0"
              style={{ backgroundColor: colors[(index + colorOffset) % colors.length] }}
            />
            <span className="text-[8px] font-semibold text-slate-500 truncate">{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default DonutWithLegend;




